import {
  deletedPendingRowStyles,
  pendingRowCellsStyles,
} from '../../AccordionDetailsView/FeeTable/FeeTable.styles';

export const adjustmentsTableStyles = {
  borderRadius: '5px',

  '& tr ': {
    height: 48,
    position: 'relative',

    ...pendingRowCellsStyles,
  },

  ...deletedPendingRowStyles,

  '& th, td': {
    border: '1px solid',
    borderColor: ({ palette }) => palette.border.default,

    '&:nth-of-type(1)': {
      minWidth: '160px',
    },

    '&:nth-of-type(2)': {
      width: '24%',
      minWidth: '160px',
    },

    '&:nth-of-type(3)': {
      width: '24%',
      minWidth: '120px',
    },

    '&:nth-of-type(4)': {
      width: '24%',
      minWidth: '90px',
    },

    '&:nth-of-type(5)': {
      width: '71px',
    },
  },

  '& tbody th, tbody td': {
    color: ({ palette }) => palette.text.secondary,
  },

  '& .table-title': {
    py: '16px',
    marginBottom: '10px',
  },
};
